export default function ReportCard({ children, style, className }) {
    return (
        <div
            className={["report-card", className].filter(Boolean).join(" ")}
            style={style}
        >
            {children}
        </div>
    );
}
